import { useContext, useEffect } from "react";
import { HashRouter, Route, Routes } from "react-router-dom";
import * as Layouts from "./Layouts";
import { UserContext } from "./context";
import { initApp, showSpinner } from "./handlers";
import { Home } from "./screens";
import Genero from "./screens/Genero";
import Registrar from "./screens/Registrar";
import Fecha from "./screens/Fecha";
import AccesoDenegado from "./screens/AccesoDenegado";
import Agotado from "./screens/Agotado";
import Confirmado from "./screens/Confirmado";
import MensajeEmail from "./screens/MensajeEmail";
import AccesoDenegadoMuni from "./screens/AccesoDenegadoMuni";
import Ingreso from "./screens/Ingreso";
import AppLayout from "./Layouts/AppLayout";
import Error from "./screens/Error";
import NoDisponible from "./screens/NoDisponible";



/* import "./index.scss" */

const App = () => {
  const { actions, loading } = useContext(UserContext);

  useEffect(() => {
    initApp(actions);
  }, []);

  showSpinner(loading);

  const NotFound = () => 404;

  return (
    <HashRouter>
      <Routes>
        {/* <Route element={<Layout perfil={actions.getPerfil()} />}> */}
        {/* <Route element={<AppLayout />}> */}

        <Route path="/" element={<Agotado />} />
        <Route path="/ingreso" element={<Agotado />} />

        {/* <Route path="/" element={<Home />} />
        <Route path="/ingreso" element={<Ingreso />} />
        <Route path="/genero" element={<Genero />} />
        <Route path="/registrar" element={<Registrar />} />
        <Route path="/acceso_denegado" element={<AccesoDenegado />} />
        <Route path="/agotado" element={<Agotado />} />
        <Route path="/confirmado_mensaje" element={<MensajeEmail />} />
        <Route path='/acceso_denegado_muni' element={<AccesoDenegadoMuni />} />

        <Route path="/no_disponible" element={<NoDisponible />} /> */}
        <Route path="*" element={<Agotado />} />
        {/* </Route> */}
        {/* </Route> */}
        {/* <Route path="/login" element={<Login />} /> */}
      </Routes>
    </HashRouter>
  );
};

export default App;
